import { CATEGORY_LIST } from '../../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {},
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case CATEGORY_LIST.LOAD:
      return {
        ...state,
        loading: true,
      };
    case CATEGORY_LIST.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false,
      };
    case CATEGORY_LIST.FAIL:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
